import { Box, styled } from "@mui/material";

export const StyledContentBox = styled(Box)`
  position: absolute;
  top: 40%;
  left: 43%;
  display: flex;
  flex-direction: column;
`;
